
// Spanish month names
export const spanishMonths = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
];

// Helper function to generate years (current year and next 5 years)
export const getYears = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 6 }, (_, i) => currentYear + i);
};

// Helper function to get days in month
export const getDaysInMonth = (year, month) => {
  return new Date(year, month + 1, 0).getDate();
};

// Helper to format dates with AM/PM in Spanish using the stored timeZone
export const formatEventDate = (date, timeZone) => {
  if (!date) return "N/A";
  return date.toLocaleString("es-ES", {
    timeZone,
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

// Lo que se puede borrar del calendario: scouting, reuniones y bloqueos. Un
// evento (`event`, o sin tipo en docs viejos) no se borra, se cancela: carga
// pagos, costos, depósitos y archivos. firestore.rules aplica lo mismo.
export const TIPOS_BORRABLES = ["scouting", "reunion", "bloqueo"];
